<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dense
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="d-none d-md-block">{{curPageName}}</v-toolbar-title>
        <v-btn to="/" icon>
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mr-15" v-bind="attrs" v-on="on">
              <v-icon >mdi-account</v-icon>
              {{userLabel}}
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title  class="text-button">切换我主管的部门:</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="(dep, index) in myManageDepartments"
              :key="index"
              @click="setMyCurManageDepartment(dep)"
            >
              <v-list-item-icon>
                <v-icon color="primary"  v-if="isMyCurManageDepartment(dep)">mdi-star</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-caption">{{ dep.departmentname}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      color="primary"
      dark
    >
      <v-list dense nav>
        <v-list-item link to='/perfdesign'>
          <v-list-item-action>
            <v-icon>mdi-target</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">绩效考核目标</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/perfscore'>
          <v-list-item-action>
            <v-icon>mdi-tune-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">绩效考核打分</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/perfsum'>
          <v-list-item-action>
            <v-icon>mdi-chart-areaspline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">绩效考核成绩</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/sysconfig' v-if="cur_user && cur_user.isAdmin">
          <v-list-item-action>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">系统管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    

    <v-main>
      <v-container fluid>
        <transition name="slide">
        <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    drawer: false
  }),
  computed: {
    ...mapState(['cur_user','departmentsettings', 'myCurManageDepartment']),
    ...mapGetters(['myManageDepartments']),

    userLabel() {
      const depart = this.myCurManageDepartment? this.myCurManageDepartment.departmentname: '*'
      return this.cur_user? `${this.cur_user.name}(${depart})${this.cur_user.isAdmin?'(管理员) ':''}`:'未登录'
    },
    curPageName() {
      return this.$route.name
    }
  },
  created () {
    // this.$vuetify.theme.dark = true
    setTimeout(this.init,0)
  },
  watch: {
  },
  methods: {
    ...mapMutations(['setMyCurManageDepartment']),

    init() {
    },

    isMyCurManageDepartment(dep) {
      return this.myCurManageDepartment && dep.departmentid === this.myCurManageDepartment.departmentid
    }
  }
};

</script>
